import { gql, useQuery } from 'urql';

const GET_EVENTS_QUERY = gql`
  query GetEvents {
    getEvents {
      events {
        name
        id
      }
    }
  }
`;

interface Event {
  name: string;
  id: number;
}

interface EventsResponse {
  getEvents: {
    events: Event[];
  };
}

export const useFetchEvents = () => {
  const [{ data, fetching, error }] = useQuery<EventsResponse>({ query: GET_EVENTS_QUERY });

  const events = data?.getEvents.events;

  return { fetching, error, events };
};
